"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledErrorBlock = exports.StyledLoader = exports.StyledButtonLink = exports.StyledLocationName = exports.StyledLocation = exports.StyledWaitTime = exports.StyledWaitTimeHeader = exports.StyledWaitTimeSection = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const button_1 = require("@kyruus/button");
const ui_theme_1 = require("@kyruus/ui-theme");
const constants_1 = require("../../lib/constants");
exports.StyledWaitTimeSection = styled_1.default.section `
  padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  background: ${(0, ui_theme_1.fromTheme)('color_background')};
  border: ${(0, ui_theme_1.fromTheme)('provider_profile_border_style')}
    ${(0, ui_theme_1.fromTheme)('provider_profile_color_border')}
    ${(0, ui_theme_1.fromTheme)('provider_profile_border_width')};
  border-radius: ${(0, ui_theme_1.fromTheme)('provider_profile_border_radius')};
  box-shadow: ${(0, ui_theme_1.fromTheme)('provider_profile_box_shadow')};

  @media screen and (min-width: ${constants_1.BREAKPOINTS.large}px) {
    margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_large')};
  }
`;
exports.StyledWaitTimeHeader = (0, styled_1.default)('h2') `
  margin: 0 0 ${(0, ui_theme_1.fromTheme)('spacing_small')} 0;
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bolder')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
`;
exports.StyledWaitTime = (0, styled_1.default)('h3') `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_2')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  margin: 0;
  line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
  padding: ${(0, ui_theme_1.fromTheme)('spacing_xsmall')} 0;
`;
exports.StyledLocation = (0, styled_1.default)('ul') `
  list-style: none;
  padding: 0;
  margin: ${(0, ui_theme_1.fromTheme)('spacing_small')} 0 0 0;

  li:nth-child(2) span {
    color: ${(0, ui_theme_1.fromTheme)('color_text')};
    font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
  }
`;
exports.StyledLocationName = (0, styled_1.default)('li') `
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
`;
exports.StyledButtonLink = (0, styled_1.default)(button_1.ButtonLink) `
  text-align: center;
  box-sizing: border-box;
  width: 100%;
  margin: ${(0, ui_theme_1.fromTheme)('spacing_large')} 0;
`;
exports.StyledLoader = (0, styled_1.default)('div') `
  display: flex;
  flex-direction: column;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_large')};
`;
exports.StyledErrorBlock = (0, styled_1.default)('div') `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_large')};

  > div > div {
    position: relative;
  }

  svg {
    position: absolute;
    top: 50%;
    transform: translateY(calc(-50% - 2px));
    margin-top: 0px;
    margin-bottom: 0px;
  }
`;
//# sourceMappingURL=styles.js.map